/**
 * <s-preorder-confirm> — closes the pre-order confirmation dialog once the
 * shopper accepts. The accept button is a normal submit button, so the
 * product form (and <s-product-form>) handles the add to cart as usual.
 */
class SPreorderConfirm extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;
      if (!event.target.closest('[data-preorder-confirm]')) return;
      // Let the submit go through first, then close the dialog.
      setTimeout(() => this.querySelector('dialog')?.close(), 0);
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-preorder-confirm')) {
  customElements.define('s-preorder-confirm', SPreorderConfirm);
}
